// Layout.js
import React from 'react';
import { useLocation } from 'react-router-dom';

// import SidebarMenu from '../SideBar/SidebarMenu';
import SidebarMenu from '../../src/components/SideBar/SidebarMenu'
import MenuScrollNav from '../../src/Menus/MenuScrollNav';
import LeftSidebar from '../../src/components/SideBar/LeftSidebar';

const Layout = ({ children }) => {
    const location = useLocation();
    const isDetailPage = location.pathname.startsWith('/project/');

    return (
        <>
            {!isDetailPage && (
                <>
                    <div className="responsive-sidebar-menu">
                        <SidebarMenu />
                    </div>
                    <MenuScrollNav />
                    <LeftSidebar />
                </>
            )}
            <main className="dev-main">
                <div id="smooth-wrapper">
                    <div id="smooth-content">
                        {children}
                    </div>
                </div>
            </main>
        </>
    );
}

export default Layout;
